import { LitElement, html } from 'lit';
import styles from './styles';
/**
 * @slot - The element's content.
 *
 * @csspart base - The element's base container.
 */
export default class AmityekoTgHeadline extends LitElement {
    render() {
        return html `<h1 part="base"><slot></slot></h1>`;
    }
}
AmityekoTgHeadline.styles = styles;
if (!customElements.get('amityeko-tg-headline')) {
    customElements.define('amityeko-tg-headline', AmityekoTgHeadline);
}
//# sourceMappingURL=index.js.map